import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Inject, inject, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ReportService } from "src/app/repository/service/report.service";
import { TrackerService } from "src/app/repository/service/tracker.service";
import { InsightsService } from "../service/insights.service";


@Component({
    selector: 'app-video-modal-new',
    templateUrl: './modal.html',
    styleUrls: ['./modal.css']
})


export class VideoModalNewComponent implements OnInit, AfterViewInit , OnDestroy{
    public startTime = 0;
    public endTime = 0;
    public startingTime = {};
    public endingTime:string;
    public isVideoHovered:boolean = false;
    public isFullScreen:boolean = false;
    public currentIndex: number = -1;
    public vocData;
    public isDescriptionVisible:boolean = true;
    public timeOut;
    public isMediaLoaded: boolean = false;
    // public videoTimeOut;
    // public durationTime = {};
    public currentVideoTime:number = 0;
    public isSideIntroOpen:boolean = false;
    public hasIntroData:boolean = false;
    public isAutoplayExecuted:boolean = false;
    public autoplayTimeout;
    public metaDataLoadedSuccefully:boolean=false;
    public currentVolumelevel:number = 1;
    public lastVolumeBeforeMute:number = 1;
    public vocUUID:string = '';
    public trackerSessionId = 0;
    public initialTimeInterval;
    public videoTileText: string;
    @ViewChild('video') video:ElementRef;
    // @ViewChild('audio') audio:ElementRef;

    constructor(
        private dialoge: MatDialog,
        @Inject(MAT_DIALOG_DATA) 
        public data:any, 
        public reportService:ReportService, 
        public iService: InsightsService,
        public trackerService:TrackerService
    ){
        
    };

    ngOnInit = () => {
    }
    
    ngAfterViewInit(): void {
        this.currentIndex = this.data.index;
        this.getCurrentFileURL();
    }

    ngOnDestroy(): void {
        clearInterval(this.initialTimeInterval);
        if (this.video) {
            this.video.nativeElement.pause();
        }
    }
    
    getCurrentFileURL(){
        this.isMediaLoaded=false;
        this.vocData = this.data.vocs[this.currentIndex];
        this.vocUUID = this.vocData.uuid;
        this.setVideoTitleText();
        if(this.data.type == 'club'){
            if(this.vocData.isQual){
                this.reportService.openQualFile({"clubbed_voc_id":this.vocData.uuid}).subscribe(result =>{
                    if (result['status'] == 1) {
                        this.setClubVideoUrl(result);
                        this.initplayer();
                    }
                });
            }
            else{
                this.reportService.openFile({"clubbed_voc_id":this.vocData.uuid}).subscribe(result =>{
                    if (result['status'] == 1) {
                        this.setClubVideoUrl(result);
                        this.initplayer();
                    }
                });
            }
        }
        else{
            this.checkForIntroData();
            if(this.vocData.isQual){
                this.reportService.openQualFile({"uuid":this.vocData.video_id,"voc_id":this.vocData.uuid}).subscribe(result =>{
                    if (result['status'] == 1) {
                        this.vocData.file_url = result['url'][0];
                        this.trackerSessionId = result['session_id'];
                        this.video.nativeElement.load();
                        this.initplayer();
                    }
                });
            }
            else{
                this.reportService.openFile({"uuid":this.vocData.video_id,"voc_id":this.vocData.uuid}).subscribe(result =>{
                    if (result['status'] == 1) {
                        this.vocData.file_url = result['url'][0];
                        this.trackerSessionId = result['session_id'];
                        // console.log("this.video is ===> ",this.video)
                        if (this.video) {
                            this.video.nativeElement.load();
                            this.initplayer();
                        }
                    }
                });
            }
        }
    }

    setClubVideoUrl(result) {
        let key = Object.keys(result['voc_data'])[0];
        if(result['voc_data'][key] && result['voc_data'][key]['url'] && result['voc_data'][key]['url']['url']){
            this.vocData.file_url = result['voc_data'][key]['url']['url'];
            this.trackerSessionId = result['session_id'];
            this.video.nativeElement.load();
        }
    }

    checkForIntroData(){
        if(this.vocData && this.vocData.misc && this.vocData.misc.preview && this.vocData.misc.preview.title){
            this.hasIntroData = true;
        }
        else{
            this.hasIntroData = false;
        }
    }

    @HostListener('window:focus', ['$event'])
    onFocused(event) {
        this.checkVideo('');
    }
    @HostListener('window:blur', ['$event'])
    onBlur(event) {
        this.checkVideo('');
    }

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if(event.key == ' '){
            this.toggleMediaPlayer();
        }
    }

    @HostListener('document:mousemove', ['$event'])
    onMouseMove(ev:MouseEvent) {
      let classListArr = Array.from(ev.target['classList']);
      clearTimeout(this.timeOut);

      if(classListArr && classListArr.includes('hover')){
          this.isVideoHovered = true;
          if(classListArr.includes('video') || classListArr.includes('close-dialog')) this.timeOut = setTimeout(()=> {this.isVideoHovered = false;},3000);
      }
      else{
          this.isVideoHovered = false;
      }
     }
     @HostListener('document:click', ['$event'])
     onClick(ev:MouseEvent){
        let classListArr = Array.from(ev.target['classList']);

        if(classListArr && classListArr.includes('video') && !classListArr.includes('lds-spinner')){
            this.toggleMediaPlayer();
        }
     }
     @HostListener('window:beforeunload',['$event'])
     unload(event)
     {
             this.video.nativeElement.pause();
             event.preventDefault();
             event.returnValue = false;
             this.checkVideo(event)
             this.submitTracker();
     }
     @HostListener('document:fullscreenchange',['$event'])
     fullScreen(event){
        console.log('Full screen change');
        let videoElem = document.querySelector('video');
        if(this.isFullScreen){
            this.isFullScreen = false; 
            videoElem.setAttribute('controls','controls');
        }
        else{
            videoElem.removeAttribute('controls');
        }
     }
     initplayer(){
        // this.video.nativeElement.load();
        this.startingTime['hour'] = '00';
        this.startingTime['minutes'] = '00';
        this.startingTime['seconds'] = '00';
        this.currentVideoTime = 0;
        this.isDescriptionVisible = true;

        this.startTime = 0;
        this.video.nativeElement.currentTime = this.startTime;
        this.initialTimeInterval = setInterval(() => {
            console.log('Time Interval getting called');
            if(this.video && this.video.nativeElement && this.video.nativeElement.duration && !isNaN(this.video.nativeElement.duration)) {
                this.endTime = this.video.nativeElement.duration;
                this.endingTime = this.getEndTime(this.endTime-this.startTime);
                this.isAutoplayExecuted = false;
                this.video.nativeElement.pause();
                this.checkVideo('');
                clearInterval(this.initialTimeInterval);
            }
            else{
                this.endingTime = '00:00:00';
            }
        }, 500);

        // this.startTime = 0;
        // this.video.nativeElement.currentTime = this.startTime;
        // this.endTime = this.video.nativeElement.duration;
        // this.endingTime = this.getEndTime(this.endTime-this.startTime);
        // this.isAutoplayExecuted = false;
        // this.video.nativeElement.pause();
        // this.checkVideo('');
     }

     toggleMediaPlayer(){
        if(this.video.nativeElement.paused){
            this.video.nativeElement.play();
        }
        else{
            this.video.nativeElement.pause(); 
        }
        if(this.isAutoplayExecuted){
            clearTimeout(this.autoplayTimeout);
        }
        this.checkVideo('');
     }
     
     playCurrentMedia(){
        // this.isDescriptionVisible = false;
        this.toggleMediaPlayer();
     }


    getTotalSeconds(timeArr){
        if(timeArr.length==3){
            return (+timeArr[2])*3600 + (+timeArr[1])*60 + (+timeArr[0]);
        }
        else{
            return (+timeArr[1])*60 + (+timeArr[0]);
        }
    }

    setCurrentTime(){
        // console.log('at set current time current time',this.video.nativeElement.currentTime);
        // console.log('at set current time start time',this.startTime);
        // if(this.video.nativeElement.currentTime>=this.startTime){
            this.isMediaLoaded = true;

            let newTime = this.video.nativeElement.currentTime - this.startTime;
    
            let currentHour = Math.floor(newTime/3600);
    
            let currentminutes = Math.floor((newTime - currentHour*3600)/60);
    
            let currentSeconds = Math.floor(newTime - currentminutes*60);
    
            this.startingTime['hour'] = currentHour>9?currentHour:'0'+currentHour;
            this.startingTime['minutes'] = currentminutes>9?currentminutes:'0'+currentminutes;
            this.startingTime['seconds'] = currentSeconds>9?currentSeconds:'0'+currentSeconds;
            this.currentVideoTime = Math.round((((this.video.nativeElement.currentTime - this.startTime)/(this.endTime - this.startTime))*100 + Number.EPSILON) * 100) / 100;
            this.mediaAutoplay();
        // }
        // else{
        //     this.video.nativeElement.pause();
        //     this.isMediaLoaded = false;
        //     // this.isDescriptionVisible = true;
        //     this.video.nativeElement.currentTime = this.startTime;
        //     // clearTimeout(this.videoTimeOut);
        // }
    }

    mediaAutoplay(){
        if(this.isAutoplayExecuted) return;
        this.isAutoplayExecuted = true;
        this.autoplayTimeout = setTimeout(()=>{
            this.video.nativeElement.play();
            this.checkVideo('');
        },4000);
    }

    getEndTime(time){
        let currentHour = Math.floor(time/3600);
        let currentminutes = Math.floor((time - currentHour*3600)/60);
        let currentSeconds = Math.floor(time - currentminutes*60);
        return `${currentHour>9?currentHour:'0'+currentHour}:${currentminutes>9?currentminutes:'0'+currentminutes}:${currentSeconds>9?currentSeconds:'0'+currentSeconds}`;
    }

    // getDurationTime(){
    //     let currentHour = Math.floor(this.video.nativeElement.duration/3600);
    //     let currentminutes = Math.floor((this.video.nativeElement.duration - currentHour*3600)/60);
    //     let currentSeconds = Math.floor(this.video.nativeElement.duration - currentminutes*60);
    //     return `${currentHour>9?currentHour:'0'+currentHour}:${currentminutes>9?currentminutes:'0'+currentminutes}:${currentSeconds>9?currentSeconds:'0'+currentSeconds}`;
    // }

    closeDialog(){
        if (this.video && this.video.nativeElement) {
            this.video.nativeElement.pause();
            this.isAutoplayExecuted = true;
            clearTimeout(this.autoplayTimeout);
        }
        this.submitTracker();
        this.dialoge.closeAll();
        // this.dialoge.closeAll(this.video);
    }


    videoTimeUpdate(e){
        this.setCurrentTime();
        // this.currentVideoTime = Math.round((((e.target.currentTime - this.startTime)/(this.endTime - this.startTime))*100 + Number.EPSILON) * 100) / 100;
        if(Math.floor(e.target.currentTime) == this.endTime){
            this.currentVideoTime = 100;
            this.video.nativeElement.pause();
            setTimeout(()=>{
                this.currentVideoTime = 0;
                this.video.nativeElement.currentTime = this.startTime;
                this.startingTime['hour'] = '00';
                this.startingTime['minutes'] = '00';
                this.startingTime['seconds'] = '00';
                this.isDescriptionVisible = true;
            },500)
        }
    }

    adjustVolume(e){
        this.currentVolumelevel = e.target.value;
        this.video.nativeElement.volume = e.target.value;
    }
    adjustVideoProgress(e){
        this.video.nativeElement.currentTime = this.startTime + (this.endTime-this.startTime)*(+e.target.value/100);
    }
    videoHovered(){
        this.isVideoHovered = true
    }
    muteUnmuteVideo(){
        this.video.nativeElement.muted = !this.video.nativeElement.muted;
        if(this.video.nativeElement.muted){
            this.lastVolumeBeforeMute = this.currentVolumelevel;
            this.currentVolumelevel = 0;
        }
        else{
            this.currentVolumelevel = this.lastVolumeBeforeMute;
        }
    }
    makeFullScreen(){
        this.isFullScreen = true;
        if (this.video.nativeElement.requestFullscreen) {
            this.video.nativeElement.requestFullscreen();
        } else if (this.video.nativeElement.msRequestFullscreen) {
            this.video.nativeElement.msRequestFullscreen();
        } else if (this.video.nativeElement.mozRequestFullScreen) {
            this.video.nativeElement.mozRequestFullScreen();
        } else if (this.video.nativeElement.webkitRequestFullscreen) {
            this.video.nativeElement.webkitRequestFullscreen();
        }
    }
    onRightClick(e){
        return false;
    }
    getPreviousVideo(){
        if(this.data.vocs[this.currentIndex-1]){
            this.currentIndex = this.currentIndex - 1;
            this.getCurrentFileURL();
        }
    }
    getNextVideo(){
        if(this.data.vocs[this.currentIndex+1]){
            this.currentIndex = this.currentIndex + 1;
            this.getCurrentFileURL();
        }
    }

    openSideIntro(){
        this.isSideIntroOpen = true;
    }

    mediaWaiting(e){
        this.isDescriptionVisible = false;
        this.isMediaLoaded = false;
    }

    mediaPlaying(e){
        this.isDescriptionVisible = false;
        this.isMediaLoaded = true;
    }

    metaDataLoaded(){
        this.isMediaLoaded = true;
    }
    mediaDataLoaded(){
        // this.initplayer();
        this.metaDataLoadedSuccefully = true;
        // console.log('Parent video time Range',`00:00:00-${this.getDurationTime()}`);
    }

    closeIntroPanel(){
        this.isSideIntroOpen = false;
    }

    checkVideo(event){
        this.trackerService.stopTimer();
        if (this.video.nativeElement.paused) {
          this.trackerService.stopTimer();
        }else{
          this.trackerService.startTimer();
        }
      }
    
      submitTracker(){
        this.trackerService.stopTimer();
        let data = {}
        data['uuid'] = this.vocUUID;
        data['file_type'] = this.data.type == 'club' ? 'clubbed_voc' : 'voc';
        data['viewtime'] = this.trackerService.interval;
        data['action'] = 'exit';
        data['session_id'] = this.trackerSessionId;
        if (data['uuid'] && data['uuid'] != '') {
            this.trackerService.submitTracker(data);
        }
        this.trackerService.interval = 0;
      }

      copyCurrentVOC() {
        if(this.data.type == 'club') {
            this.iService.copyVocURL({'clubbed_voc_uuid':this.vocData.uuid});
        }
        else{
          this.iService.copyVocURL({'uuid':this.vocData.uuid});
        }
    }

    setVideoTitleText() {
        if(this.data.type == 'club') {
            if(this.vocData && this.vocData.name) {
                this.videoTileText = this.vocData.name;
            }
        }
        else {
            if(this.vocData && this.vocData.misc && this.vocData.misc.comment) {
                this.videoTileText = this.vocData.misc.comment;
            }
        }
    }
    
}